export const API_BASE_URL = 'https://illolam.com/api';
export const IMAGE_BASE_URL = 'https://illolam.com/img';
export const APPIMAGE_BASE_URL = 'https://illolam.com/appimg';
export const PICKUP_NAME = 'Anjana artech';
export const SELLER_GSTIN = "32AJNPA9627K1Z0";       // <-- your 15-char GSTIN